import { createAsyncActions } from "@ctra/utils";
import { normalize } from "normalizr";

import schemas from "./schemas";
import types from "./types";
import { FarmEntity } from "../farms";
import { DataDescriptorEntity } from "../data-dictionary";
import { ScorecardValueParams } from "./typings";
import { makeScorecardHash } from "./utils";

/**
 * Payload for the FETCH_SCORECARD_VALUE.pending action
 */
export type FetchScorecardValuePendingPayload = {
  /**
   * auto-generated scorecard hash
   */
  hash: string;
  /**
   * data descriptor id
   */
  dataDescriptorID: DataDescriptorEntity["id"];
  /**
   * farm id
   */
  farmID: FarmEntity["id"];
} & ScorecardValueParams;

/**
 * Payload for the FETCH_SCORECARD_VALUE.fulfilled action
 * @todo add the rest of the keys
 */
export type FetchScorecardValueFulfilledPayload = {
  /**
   * auto-generated scorecard hash
   */
  hash: string;
};

/**
 * Fetch scorecard value
 * @category Action
 */
const fetchScorecardValue = createAsyncActions(
  types.FETCH_SCORECARD_VALUE,
  (
    dataDescriptorID: DataDescriptorEntity["id"],
    farmID: FarmEntity["id"],
    params: ScorecardValueParams
  ): FetchScorecardValuePendingPayload => {
    const payload = { dataDescriptorID, farmID, ...params };

    return {
      hash: makeScorecardHash(dataDescriptorID, farmID, params),
      ...payload
    };
  },
  (hash: string, valueResponse): FetchScorecardValueFulfilledPayload => ({
    hash,
    ...normalize(valueResponse, schemas.scorecardValue)
  }),
  (hash, error: string) => ({ hash, error })
);

export default {
  fetchScorecardValue
};
